import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 贸易PO信息
export function poList(params) {
  return request({
    url: URL.seaExport.poList,
    method: 'get',
    params
  })
}
